import VueRouter from 'vue-router';

let routes = [
  {
    path: '/',
    component: require('../views/main-page/list').default,
    children: [
      {
        path: '/:search',
        component: require('../views/main-page/list').default
      },
      {
        path: '/tag/:tag',
        component: require('../views/main-page/list').default
      }
    ]
  },
  {
    path: '/add/new',
    component: require('../views/add-page/form').default
  },
  {
    path: '/update/:id',
    component: require('../views/update-page/update').default
  },
  {
    path: '/view/:id',
    component: require('../layouts/view-page').default,
    children: [
      {
        path: '',
        redirect: 'about',
      },
      {
        path: 'about',
        component: require('../views/view-page/about').default
      },
      {
        path: 'activities',
        component: require('../views/view-page/activities').default
      },
      {
        path: 'articles',
        component: require('../views/view-page/articles').default
      },
      {
        path: 'products',
        component: require('../views/view-page/products').default
      },
      {
        path: 'events',
        component: require('../views/view-page/events').default
      },
      {
        path: 'media',
        component: require('../views/view-page/media').default
      },
      {
        path: 'members',
        component: require('../views/view-page/members').default
      },
      {
        path: 'careers',
        component: require('../views/view-page/careers').default
      },
    ]
  },
];

export default new VueRouter({
  base: '/about',
  routes,
  linkExactActiveClass: 'active'
});
